import { useState } from "react";
import { Button, ErrorMessage, Flex, Label, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { AssignedToPicker } from "../../../DDQueue/Drawer/AssignedToPicker";

export type MarkReadyForReviewModalProps = {
  errorMessage: string | null;
  isSubmitting: boolean;
  onHide: () => void;
  onConfirm: (checkerId: string) => void;
};

// No dedicated checker role exists — the picker reuses the same admin-placeholder eligibility
// assigning the process task already carries.
export const MarkReadyForReviewModal = ({
  errorMessage,
  isSubmitting,
  onHide,
  onConfirm,
}: MarkReadyForReviewModalProps) => {
  const [checkerId, setCheckerId] = useState<string | null>(null);

  return (
    <ModalV2
      show
      onHide={onHide}
      title="Assign reviewer"
      size="small"
      data-testid="ddq-mark-ready-modal"
    >
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.LARGE}>
          <Text variant="secondary-md">
            Select a reviewer and mark this task ready to review.
          </Text>
          <div>
            <Label>Assignee</Label>
            <AssignedToPicker onSelectAssignee={setCheckerId} disabled={isSubmitting} />
          </div>
          {errorMessage && (
            <ErrorMessage data-testid="ddq-mark-ready-error">{errorMessage}</ErrorMessage>
          )}
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex flexDirection="row" gap={SPACING.SMALL} justifyContent="flex-end">
          <Button variant="neutral" onClick={onHide} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            isLoading={isSubmitting}
            disabled={!checkerId || isSubmitting}
            onClick={() => checkerId && onConfirm(checkerId)}
            data-testid="ddq-mark-ready-confirm"
          >
            Assign reviewer
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
